import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  runInPlaceRestore(vmId, vcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/restore';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/in-place-restore/in-place-restore.service.ts